import { render, staticRenderFns } from "./OperaLabelsOtherWindow.vue?vue&type=template&id=28da4396&scoped=true&"
import script from "./OperaLabelsOtherWindow.vue?vue&type=script&lang=js&"
export * from "./OperaLabelsOtherWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaLabelsOtherWindow.vue?vue&type=style&index=0&id=28da4396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28da4396",
  null
  
)

export default component.exports